import { useState } from "react";
import moment from "moment";

// Datos de cabecera del pedido: fecha, observaciones y "Para Cambio".
export const useDatosPedido = () => {
  const [datosPedido, setdatosPedido] = useState({
    observaciones: "",
    fecha_para: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
  });
  const [pedidoCambio, setPedidoCambio] = useState(false);

  const almacenar = (e) => {
    setdatosPedido({
      ...datosPedido,
      [e.target.name]: e.target.value,
    });
  };

  const handlePedidoCambioChange = (event) => {
    setPedidoCambio(event.target.checked);
  };

  return {
    datosPedido,
    almacenar,
    pedidoCambio,
    handlePedidoCambioChange,
    pedidoParaCambio: pedidoCambio === true ? 1 : 0,
  };
};
